import { render, staticRenderFns } from "./QuizTeacherTestResult.vue?vue&type=template&id=9774f616&"
import script from "./QuizTeacherTestResult.vue?vue&type=script&lang=js&"
export * from "./QuizTeacherTestResult.vue?vue&type=script&lang=js&"
import style0 from "./QuizTeacherTestResult.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports